import memosReducer from './memos';

export default memosReducer;
